import { render, staticRenderFns } from "./account-profile.vue?vue&type=template&id=70d2aaff&"
import script from "./account-profile.vue?vue&type=script&lang=js&"
export * from "./account-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports